<div class="container-fluid footer bg-gray_1 ">
  <div class="footer__padding">
    <div class="row flex-row-reverse">

      <div class="col">
        <div class="px-4">
          <div class="row">
            <div class="col-2 flex-wrap d-flex align-items-start">
              <img width="80%" [imageDirective]="{
                src : 'assets/img/hmasaz-saman-logo.svg'
              }">
            </div>

            <div class="col-10">
              <div class="row">

                <div class="col-lg-2 col-md-4 col-4">
                  <div class="d-flex flex-column gap-3">
                    <span class="font-XL-lg font-XL-md font-M1-sm bold">دسترسی سریع</span>
                    <a RouteNavigate [subRoute]="faqs" class="font-M1-lg font-M1-md font-M2-sm regular">سوالات
                      متداول</a>
                    <a href="https://blog.hamsazhiva.com/" target="_blank"
                      class="font-M1-lg font-M1-md font-M2-sm regular">وبلاگ</a>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-4">
                  <div class="d-flex flex-column gap-3">
                    <a RouteNavigate [subRoute]="terms" class="font-M1-lg font-M1-md font-M2-sm regular">قوانین و
                      مقررات</a>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-4 ">
                  <div class="d-flex flex-column gap-3">
                    <span class="font-XL-lg font-XL-md font-M1-sm bold">ارتباطات</span>

                    <span class="mt-2 font-M1-lg font-M1-md font-M2-sm regular"><i
                        class="fa-regular fa-phone ms-2"></i>۰۳۵-۳۸۳۴۲۳۱۷</span>
                    <span class="font-M1-lg font-M1-md font-M2-sm regular"><i
                        class="fa-regular fa-location-dot ms-2"></i>یزد،
                      صفائیه، بلوار دانشگاه، ساختمان فناوری
                      دو</span>
                    <span class="font-M1-lg font-M1-md font-M2-sm regular"><i
                        class="fa-regular fa-envelope ms-2"></i>۸۹۱۵۸۱۸۴۱۱</span>

                  </div>
                </div>

                <div class="col-lg-4 col-md-12 col-12 ">
                  <div lass="d-flex flex-column">
                    <span class="font-XL-lg font-XL-md font-M1-sm bold">مجوزها</span>
                    <div class="row row-gap-2">
                      <div class="col-lg-4 col-6 footer__upperPart__permissions__width">
                        <a target="_blank" href="assets/img/nezam-senfi.jpeg">
                          <img [imageDirective]="{
                            src : 'assets/img/nezam-senfi.png',
                          }" class="footer__upperPart__permissions__logo">
                        </a>
                      </div>
                      <div class="col-lg-4 col-6 footer__upperPart__permissions__width ">
                        <a href="https://ystp.ac.ir/">
                          <img [imageDirective]="{
                            src : 'assets/img/park-elemo-fanavari.png'
                          }" class="footer__upperPart__permissions__logo">
                        </a>
                      </div>
                      @if(mode === 'hamsaz') {
                      <div class="col-lg-4 col-6  footer__upperPart__permissions__width">
                        <a referrerpolicy='origin' target='_blank'
                          href='https://trustseal.enamad.ir/?id=428583&Code=pQtgFiXAjDXUEzyttLCI1uQRK2QS396z'>
                          <img referrerpolicy='origin'
                          [imageDirective]="{
                            src : 'https://trustseal.enamad.ir/logo.aspx?id=428583&Code=pQtgFiXAjDXUEzyttLCI1uQRK2QS396z',
                          }" style='cursor:pointer' code='pQtgFiXAjDXUEzyttLCI1uQRK2QS396z'>
                        </a>
                      </div>
                      }
                      <div class="col-lg-4 col-6 footer__upperPart__permissions__width">
                        <a target="_blank" href="assets/img/etehadie.pdf">
                          <img [imageDirective]="{
                            src : 'assets/img/etehadie-logo.svg',
                          }" class="footer__upperPart__permissions__logo">
                        </a>
                      </div>
                      <div class="col-lg-4 col-6 footer__upperPart__permissions__width">
                        <a href="#">
                          <img [imageDirective]="{
                            src : 'assets/img/daneshgah-yazd.png',
                          }" class="footer__upperPart__permissions__logo">
                        </a>
                      </div>
                      <div class="col-lg-4 col-6 footer__upperPart__permissions__width">
                        <a target="_blank" href="assets/img/InformaticsCertificateReport (1).pdf">
                          <img [imageDirective]="{
                            src : 'assets/img/sazman-barname-boodge.png'
                          }" class="footer__upperPart__permissions__logo">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 col-12 my-4">
                  <div class="d-flex flex-row align-items-center">
                    <span class="font-XL-lg font-XL-md font-L-sm black text-nowrap primary_7">ما را در شبکه
                      های
                      اجتماعی دنبال کنید !</span>
                    <div class="footer__line-right bg-gray_5"></div>
                    <div class="d-flex flex-row align-items-center gap-2">
                      <!-- TODO: check eitaa logo by adel -->
                      <a href="https://www.instagram.com/hamsazhiva/" target="_blank">
                        <img [imageDirective]="{
                          src : 'assets/img/instagram.png',
                          alt : 'instagram-logo'
                        }" class="footer__upperPart__socials__eitaa">
                      </a>
                      <a href="" target="_blank">
                        <img [imageDirective]="{
                          src : 'assets/img/whatsapp.png',
                          alt : 'whatsapp-logo'
                        }" class="footer__upperPart__socials__eitaa">
                      </a>
                      <a href="https://www.linkedin.com/company/hamsazhiva/" target="_blank">
                        <img [imageDirective]="{
                          src : 'assets/img/linkedin.png',
                          alt : 'linkedin-logo'
                        }" class="footer__upperPart__socials__eitaa">
                      </a>
                      <a href="https://eitaa.com/Hamsaz_hiva" target="_blank">
                        <img [imageDirective]="{
                          src : 'assets/img/Eitaa-Logo.png',
                          alt : 'eitaa-logo'
                        }" class="footer__upperPart__socials__eitaa">
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="col-10 d-flex flex-column">
        <span class="font-XL-lg font-XL-md font-M1-sm bold mb-2">همسازسامان</span>
        <span class="font-M2-sm regular footer-desc">
          {{displayText}}
        </span>

        @if(!isExpanded){
        <app-button-loader [button]="showMoreBtn"></app-button-loader>
        } @else{
        <app-button-loader [button]="showLessBtn"></app-button-loader>
        }
      </div>

    </div>
  </div>
</div>



<div class="container-fluid footer-responsive bg-gray_1">
  <div class="footer_responsive_padding">
    <div class="row">
      <div class="col-12">

        <div class="pt-3">
          <p-accordion [value]="0">
            <p-accordion-panel value="0">
              <p-accordion-header>دسترسی سریع</p-accordion-header>
              <p-accordion-content>
                <div class="d-flex flex-column gap-2">
                  <a RouteNavigate [subRoute]="faqs" class="font-M2-sm regular" cy-button="سوالات متداول">سوالات
                    متداول</a>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="1">
              <p-accordion-header>همسازسامان</p-accordion-header>
              <p-accordion-content>
                <div class="d-flex flex-column gap-2">
                  <a RouteNavigate [subRoute]="terms" class="font-M2-sm regular" cy-button="قوانین و مقررات فوتر">قوانین
                    و مقررات</a>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="2">
              <p-accordion-header>ارتباطات</p-accordion-header>
              <p-accordion-content>
                <div class="d-flex flex-column">
                  <span class="mt-2 font-M2-sm regular"><i class="fa-regular fa-phone ms-2"></i>۰۳۵-۳۸۳۴۲۳۱۷</span>
                  <span class="font-M2-sm regular"><i class="fa-regular fa-location-dot ms-2"></i>یزد،
                    صفائیه، بلوار دانشگاه، ساختمان فناوری
                    دو</span>
                  <span class="font-M2-sm regular"><i class="fa-regular fa-envelope ms-2"></i>۸۹۱۵۸۱۸۴۱۱</span>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex justify-content-center gap-3 mt-3 flex-wrap">

          <a target="_blank" href="assets/img/nezam-senfi.jpeg">
            <img [imageDirective]="{
              src : 'assets/img/nezam-senfi.png'
            }" class="footer__upperPart__permissions__logo">
          </a>
          <a href="#">
            <img [imageDirective]="{
              src : 'assets/img/park-elemo-fanavari.png'
            }" class="footer__upperPart__permissions__logo">
          </a>
          @if(mode === 'hamsaz'){
          <a referrerpolicy='origin' target='_blank'
            href='https://trustseal.enamad.ir/?id=428583&Code=pQtgFiXAjDXUEzyttLCI1uQRK2QS396z'>
            <img referrerpolicy='origin'
            [imageDirective]="{
              src : 'https://trustseal.enamad.ir/logo.aspx?id=428583&Code=pQtgFiXAjDXUEzyttLCI1uQRK2QS396z'
            }" style='cursor:pointer' code='pQtgFiXAjDXUEzyttLCI1uQRK2QS396z'>
          </a>
          }
          <a target="_blank" href="assets/img/etehadie.pdf">
            <img [imageDirective]="{
              src : 'assets/img/etehadie-logo.svg',
            }" class="footer__upperPart__permissions__logo">
          </a>
          <a href="#">
            <img [imageDirective]="{
              src : 'assets/img/daneshgah-yazd.png',
            }" class="footer__upperPart__permissions__logo">
          </a>
          <a target="_blank" href="assets/img/InformaticsCertificateReport (1).pdf">
            <img [imageDirective]="{
              src : 'assets/img/sazman-barname-boodge.png',
            }" class="footer__upperPart__permissions__logo">
          </a>
        </div>
      </div>
      <span class="footer-responsive__line"></span>
      <div class="col-12">
        <div class="d-flex flex-column align-items-center gap-2">
          <span class="font-L-sm bold text-nowrap">ما را در شبکه های اجتماعی دنبال کنید !</span>
          <div class="d-flex flex-row align-items-center gap-3">
            <a href="https://www.instagram.com/hamsazhiva/" target="_blank">
              <img [imageDirective]="{
                src : 'assets/img/instagram.png',
                alt : 'instagram-logo'
              }" class="footer__upperPart__socials__eitaa">
            </a>
            <a href="" target="_blank">
              <img [imageDirective]="{
                src : 'assets/img/whatsapp.png',
                alt : 'whatsapp-logo'
              }" class="footer__upperPart__socials__eitaa">
            </a>
            <a href="https://www.linkedin.com/company/hamsazhiva/" target="_blank">
              <img [imageDirective]="{
                src : 'assets/img/linkedin.png',
                alt : 'linkedin-logo'
              }" class="footer__upperPart__socials__eitaa">
            </a>
            <a href="https://eitaa.com/Hamsaz_hiva" target="_blank">
              <img [imageDirective]="{
                src : 'assets/img/Eitaa-Logo.png',
                alt : 'eitaa-logo'
              }" class="footer__upperPart__socials__eitaa">
            </a>
          </div>
        </div>
      </div>
      <span class="footer-responsive__line"></span>
      <div class="col-12">
        <div class="d-flex flex-column">
          <span class="font-M1-sm bold">همساز سامان</span>
          <span class="font-M2-sm regular footer-responsive-desc">
            {{displayText}}

          </span>

          @if(!isExpanded){
          <app-button-loader [button]="showMoreBtn"></app-button-loader>
          } @else{
          <app-button-loader [button]="showLessBtn"></app-button-loader>
          }

        </div>
      </div>
    </div>
  </div>
</div>